export default __webpack_public_path__ + "static/WebSite_3DShowcaseYape_VideoQHD-4a3ee77f38400eaa0782de91dda3ccfa.mp4";